var Gainsight = (function(backOffice, $) {
    
    backOffice.Integration.Gainsight = (function() {
        var scopeSelector = backOffice.options.scopeSelector;
        var gainsightKey, clientId, retailAccount, userCode, firstName, lastName, segment, win, doc, appVersion, userPermission;

        
        var isLoaded = {
            get: function() {
                return $("#gainsightLoaded", scopeSelector).val();
            },
            set: function() {
                $("#gainsightLoaded", scopeSelector).val("true");
            },
            init: function() {
                //create a hidden element to store whether the Gainsight is loaded or not
                if (!$("#gainsightLoaded", scopeSelector).length) {
                    $('<input type="hidden" id="gainsightLoaded" value="false" />').prependTo(scopeSelector);
                }
            }
        }
        
        var loadGainsight = function() {
            if (isLoaded.get() !== "true") {
                isLoaded.set();

                // Gainsight PX Tag
                (function (n, t, a, e, x) {   
                        let i = "aptrinsic"; n[i] = n[i] || function () {
                                (n[i].q = n[i].q || []).push(arguments)
                            }, 
                            n[i].p = e, n[i].c = x;
    
                        let r = t.createElement("script");
                        r.async = !0;
                        r.src = a + "?a=" + e;        
    
                        let c = t.getElementsByTagName("script")[0];
                        c.parentNode.insertBefore(r, c);
                    })
                    (win, doc, "https://web-sdk.aptrinsic.com/api/aptrinsic.js", gainsightKey, { "iframeModeEnabled": false });
                // End Gainsight PX Tag    
            }
        }
        
        var identify = function() {
            aptrinsic("identify",
                {
                    "id": clientId + "-" + userCode,
                    "firstName": firstName,
                    "lastName": lastName,
                    "userPermission": userPermission
                },
                {
                    "id": clientId,
                    "name": retailAccount,
                    "releaseSegment": segment.replace(/^\/|\/$/g, '').substring(0, 2),
                    "appVersion": appVersion
                });
        }
        
        var initialise = function(options) {
            $.extend(backOffice.options, options);
            scopeSelector = backOffice.options.scopeSelector;
            gainsightKey = options.gainsightKey;
            clientId = options.clientId;
            retailAccount = options.retailAccount;
            userCode = options.userCode;
            firstName = options.firstName;
            lastName = options.lastName;
            segment = options.segment;
            win = options.win;
            doc = options.doc;
            appVersion = getAppVersionFromSourceBranch(options.sourceBranch);

            if (options.isAdmin != null && options.isAdmin != undefined) {
                userPermission = options.isAdmin ? "admin user" : "user";
            }
            loadGainsight();

            if(BackOffice.Utils.GetCookie("ReX_CallBackLogin")){
                BackOffice.Utils.SetCookie("ReX_CallBackLogin", null, 1);

                identify();
            }
            
            isLoaded.init();
        }

        var logout = function(){
            if(window.aptrinsic){
                window.aptrinsic('reset');
            }
        }

        function getAppVersionFromSourceBranch(sourceBranch) {
            if (!sourceBranch)
                return 'N/A';
            else {
                var branchParts = sourceBranch.split('/');
                return branchParts[branchParts.length - 1];
            }
        }

        return $.extend(backOffice.Integration.Gainsight,
            {
                Init: initialise,
                Identify: identify,
                Logout: logout
            });
    })();
    return backOffice.Integration.Gainsight;
})(BackOffice || {}, jQuery);